import { ADMIN_WIDGETS } from "src/constants/widgets";
import { SCROLL_TYPE } from "../NewAnnouncementBar/Constants";
import { getDefaultConfig } from "src/components/WidgetMaker/utils/common";
import { ASPECT_RATIO_MAP, DESCRIPTION_POSITION, LAYOUT_STYLE, TEXT_CASE, TEXT_THICKNESS } from "src/constants/builderConstants";
import { getCardShare } from "../../components/RowItemImageText";
import { HEADING_ALIGNMENT, HOVER_EFFECT_DROPDOWN } from "../MultiColumn/MultiColumnStaticValues";
import {
  CARD_SHAPE_DROPDOWN as COMMON_CARD_SHAPE_DROPDOWN,
  TEXT_SIZE_DROPDOWN,
} from '../ListPresentation/ListPresentationConfig';
import { COMMON_LAYOUT_TYPE, IMAGE_TYPES } from "src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Constants";
import { PRODUCT_APPEARANCE_DATA } from "../../GlobalStyle/globalSettingConstant";
import { ICardDefaultConfigProps } from "src/components/DesignSystem/Widgets2.0/ListPresentation/components/Testimonials/Types";

export const PRODUCT_TESTIMONIALS_LAYOUT = [
  {
    name: 'layout1',
    heading: 'Layout 1',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/dzJxwHTf.webp',
    // These are the base configs meapped with each layout
    list: {
      layoutName: 'layout1',
      appearance: 'standard',
      layoutType: 'carousel',
      numColumnsDesktop: 3,
      textAlign: 'left'
    },
    card: {
      productPosition: 'top'
    },
  },
  {
    name: 'layout2',
    heading: 'Layout 2',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/yD9huIdb.webp',
    // These are the base configs mapped with each layout
    list: {
      layoutName: 'layout2',
      appearance: 'standard',
      layoutType: 'carousel',
      numColumnsDesktop: 1,
    },
    card: {
      productPosition: 'left'
    },
  },
  {
    name: 'layout3',
    heading: 'Layout 3',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/MVBkJJx1.webp',
    // These are the base configs mapped with each layout
    list: {
      layoutName: 'layout3',
      appearance: 'standard',
      layoutType: 'carousel',
      numColumnsDesktop: 3,
    },
    card: {
      productPosition: 'top'
    },
  },
  {
    name: 'layout4',
    heading: 'Layout 4',
    cdn: 'https://cdn.dotpe.in/longtail/themes/8073865/C9ZDbE3v.webp',
    // These are the base configs mapped with each layout
    list: {
      layoutName: 'layout4',
      appearance: 'standard',
      layoutType: 'carousel',
      numColumnsDesktop: 1,
      numColumnsMobile: 1,
      textAlign: 'center',
      autoPlayConfig: {
        type: SCROLL_TYPE.AUTO_ROTATE,
        autoplayTimer: 22.5,
        autoRotateTimer: 4
      }
    },
    card: {
      textAlign: 'center',
    },
  },
];

export const PRODUCT_TESTIMONIAL_GAP = {
  layout1: {
    row: {
      mobile: 44,
      desktop: 60,
    },
    carousel: {
      mobile: 16,
      desktop: 44,
    },
    grid: {
      mobile: 16,
      desktop: 44,
    },
    card: {
      desktop: 20,
      mobile: 12
    }
  },
  layout2: {
    row: {
      mobile: 44,
      desktop: 60,
    },
    grid: {
      mobile: 16,
      desktop: 44,
    },
    carousel: {
      mobile: 16,
      desktop: 44,
    },
    card: {
      desktop: 20,
      mobile: 12
    }
  },
  layout3: {
    row: {
      mobile: 36,
      desktop: 60,
    },
    grid: {
      mobile: 16,
      desktop: 44
    },
    carousel: {
      mobile: 16,
      desktop: 44
    },
    card: {
      desktop: 20,
      mobile: 12
    }
  },
  layout4: {
    row: {
      mobile: 12,
      desktop: 20,
    },
    grid: {
      mobile: 12,
      desktop: 20
    },
    carousel: {
      mobile: 12,
      desktop: 20
    },
  }
}

export const PRODUCT_TESTIMONIALS_CARD_DEFAULT_CONFIGS: { [layout: string]: ICardDefaultConfigProps } = {
  layout1: {
    cardWrapperConfig: {
      showBorder: false,
      padding: '35px 28px',
    },
    productImageConfig: {
      maxHeight: 350,
    },
    productImageMobileConfig: {
      maxHeight: 350,
    },
    imageConfig: {
      showImage: true,
      showImageWithAuthorInfo: true,
      imageType: IMAGE_TYPES.CIRCLE,
      width: 40,
      height: 40,
    },
    infoWrapperConfig: {
      gap: 24,
    },
    reviewConfig: {},
    authorInfoConfig: {
      gap: 0,
      authornameConfig: {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
      },
      authorProfileConfig: {
        fontWeight: 400,
      },
    },
  },
  layout2: {
    cardWrapperConfig: {
      showBorder: false,
      padding: '35px 28px',
    },
    productImageConfig: {
      maxHeight: 300,
      minWidth: 120,
      maxWidth: 450
    },
    productImageMobileConfig: {
      maxHeight: 300,
      minWidth: 120,
      maxWidth: 450
    },
    imageConfig: {
      showImage: true,
      showImageWithAuthorInfo: true,
      imageType: IMAGE_TYPES.CIRCLE,
      width: 40,
      height: 40,
    },
    infoWrapperConfig: {
      gap: 24,
    },
    reviewConfig: {},
    authorInfoConfig: {
      gap: 0,
      authornameConfig: {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
      },
      authorProfileConfig: {
        fontWeight: 400,
      },
    },
  },
  layout3: {
    cardWrapperConfig: {
      showBorder: false,
      flexDirection: 'column',
      gap: 18,
    },
    productImageConfig: {
      height: 80,
      width: 80
    },
    productImageMobileConfig: {
      height: 56,
      width: 56
    },
    imageConfig: {
      showImage: true,
      showImageWithAuthorInfo: false,
      imageType: IMAGE_TYPES.CIRCLE,
      width: 76,
      height: 76,
    },
    infoWrapperConfig: {
      gap: 10.5,
    },
    reviewConfig: {},
    authorInfoConfig: {
      gap: 0,
      alignItems: 'center',
      authornameConfig: {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 600,
      },
      authorProfileConfig: {
        fontWeight: 400,
      },
    },
  },
  layout4: {
    showAuthorImageList: true,
    cardWrapperConfig: {
      showBorder: false,
      paddingBottom: 100,
    },
    imageConfig: {
      showImage: false,
      showImageWithAuthorInfo: false,
      imageType: IMAGE_TYPES.CIRCLE,
      width: 40,
      height: 40,
    },
    infoWrapperConfig: {
      gap: 16,
    },
    reviewConfig: {
      marginTop: 8,
      gap: 16,
    },
    authorInfoConfig: {},
  },
};

export const SPEED_OPTION = [
  {
    text: 'Slowest',
    value: 45,
  },
  {
    text: 'Slow',
    value: 30,
  },
  {
    text: 'Normal',
    value: 22.5,
  },
];

export const PRODUCT_TESTIMONIALS_PRESENTATION_CONFIG = {
  layoutName: 'layout1',
  viewLabel: 'Product testimonials',
  widgetName: ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type,
  layoutType: 'carousel',
  heading: '<h1>Customers love our products</h1>',
  descriptionPosition: 'below',
  textAlign: 'left',
  headingCharCount: 0,
  instagramAccount: '',
  description: '',
  descriptionCharCount: 0,
  type: ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.type,
  colors: {
    selectedColorSchemeIndex: 0,
    colorSchemes: [
      {
        background: '#ffffff',
        text: '#000000',
        isDefault: true,
      },
      {
        background: '#000000',
        text: '#ffffff',
        isDefault: false,
      },
    ],
  },
  contentItems: {
    isAllSelected: false,
    type: 'testimonials',
    listItem: [],
  },
  appearance: 'standard',
  imageWidth: 'fullWidth',
  backgroundColor: '#FFFFFF',
  borderColor: '#E2E4E7',
  numColumnsDesktop: 3,
  numColumnsMobile: 1,
  mobilePaddingY: 40,
  paddingY: 70,
  marginTop: 0,
  marginBottom: 0,
  autoPlayConfig: {
    type: SCROLL_TYPE.MANUAL,
    autoplayTimer: 22.5,
    autoRotateTimer: 4,
  },
  viewAllItemsButtonConfig: [
    getDefaultConfig('bannerButton', '#111C36', '#FFFFFF', 'View all'),
  ],
};

export const PRODUCT_TESTIMONIALS_CARD_CONFIG = {
  cardShape: 'portraitTall',
  aspectRatio: ASPECT_RATIO_MAP.portraitTall,
  productAspectRatio: ASPECT_RATIO_MAP.square,
  productPosition: 'top',
  hoverEffect: 'zoomIn',
  textAlign: 'left',
  textSizeDesktop: 'medium',
  textSizeMobile: 'medium',
  headlineSizeDesktop: 'medium',
  headlineSizeMobile: 'small',
  headlineColor: '#111C36',
  reviewColor: '#111C36E6',
  authorNameColor: '#111C36',
  designationColor: '#111C36B3',
  ratingColor: '#F9CC43',
  textThickness: 'regular',
  headlineThickness: 'semiBold',
  textCase: 'none',
  headlineCase: 'none',
  hoverType: 'zoomIn',
  showRatings: true,
  showImage: true,
  imageSizeDesktop: 40,
  imageSizeMobile: 40,
  authorImagePosition: 'withAuthorInfo',
  imageShape: 'circle',
  productImageShape: 'square',
  testimonialsList: [
  ],
  selectedReviewsId: [],
  childElementOrder: [
    {
      name: 'Rating',
      id: 'rating',
      isSortable: true,
    },
    {
      name: 'Review',
      id: 'review',
      isSortable: true,
    },
    {
      name: 'Author info',
      id: 'authorInfo',
      isSortable: true,
    },
  ],
  buttonConfig: [
    {
      ...getDefaultConfig('bannerButton', '#111C36', '#FFFFFF', 'Shop now'),
    },
  ],
};

export const CARD_SHAPE_DROPDOW = [
  {
    value: 'square',
    renderData: () => getCardShare('Square'),
  },
  {
    value: 'circle',
    renderData: () => getCardShare('Circle'),
  },
  {
    value: 'smart',
    renderData: () => getCardShare('Logo friendly (Smart fit in Rectangle or square)'),
  },
];

export const PRODUCT_CONTENT_CONFIG_FOR_L1_L2 = [
  {
    text: 'Top',
    value: 'top'
  },
  {
    text: 'Bottom',
    value: 'bottom'
  }
]

export const PRODUCT_CONTENT_CONFIG_FOR_L3 = [
  {
    text: 'Left',
    value: 'left'
  },
  {
    text: 'Right',
    value: 'right'
  }
]

export const PRODUCT_TESTIMONIAL_BUILDER_CONFIG = {
  sectionContent: {
    sectionHeading: 'Section content',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'layout',
        componentLabel: 'Heading',
        element: 'inputEditor',
        accessKey: ['heading'],
        charCountKey: 'headingCharCount',
        placeholder: 'Enter title',
        maxLength: 100,
      },
      {
        forType: 'layout',
        componentLabel: 'Description',
        element: 'inputEditor',
        placeholder: 'Enter description',
        charCountKey: 'descriptionCharCount',
        accessKey: ['description'],
        textColor: '#808080',
        maxLength: 100,
      },
      {
        forType: 'layout',
        componentLabel: 'Description position',
        element: 'multiselect',
        accessKey: ['descriptionPosition'],
        componentData: DESCRIPTION_POSITION,
      },
      {
        forType: 'layout',
        componentLabel: 'Heading alignment',
        element: 'multiselect',
        accessKey: ['textAlign'],
        componentData: HEADING_ALIGNMENT,
      },
      {
        forType: 'layout',
        componentLabel: 'Section colour',
        editLabel: 'Edit colour',
        uniqueKey: 'selectionColors',
        element: 'colorsCombination',
        accessKey: ['colors'],
      },
    ],
  },
  imageAndRatings: {
    sectionHeading: 'Image and ratings',
    description: '',
    tooltipContent: '',
    builder: [
      {
        element: 'renderWithHeading',
        heading: '',
        child: [
          {
            forType: 'card',
            element: 'checkbox',
            componentLabel: 'Show ratings',
            accessKey: ['showRatings'],
          },
        ],
      },
      {
        forType: 'card',
        element: 'dropdown',
        componentLabel: 'Product image shape',
        accessKey: ['productImageShape'],
        componentData: COMMON_CARD_SHAPE_DROPDOWN,
        customChildRender: true,
        placeholder: '',
      },
      {
        forType: 'layoutItem',
        element: 'dropdown',
        componentLabel: 'hover effect',
        accessKey: ['hoverEffect'],
        dropdownData: HOVER_EFFECT_DROPDOWN,
        customChildRender: false,
        placeholder: '',
      },
    ],
  },
  layoutAndDesign: {
    sectionHeading: 'Layout & design',
    description: '',
    tooltipContent: '',
    builder: [
      {
        componentLabel: 'Layout/design',
        element: 'testimonialLayout',
        componentData: PRODUCT_TESTIMONIALS_LAYOUT,
      },
      {
        forType: 'layout',
        element: 'multiselect',
        componentLabel: 'Layout style',
        accessKey: ['layoutType'],
        dynamicData: false,
        componentData: LAYOUT_STYLE,
        renderConditional: true,
        isVisible: (activeWidgetProps) =>
          activeWidgetProps?.listPresentation?.layoutName !== 'layout4',
      },
      {
        forType: 'layout',
        componentLabel: 'Number of columns - Desktop',
        element: 'slider',
        accessKey: ['numColumnsDesktop'],
        min: 1,
        max: 2,
        dynamicData: true,
        getDynamicData: (activeWidgetProps) => {
          const layoutPresentation = activeWidgetProps?.listPresentation;
          switch (layoutPresentation.layoutName) {
            case COMMON_LAYOUT_TYPE.FOUR:
              return { min: 1, max: 1 };
            case COMMON_LAYOUT_TYPE.TWO:
              return {
                min: 1,
                max: 2,
              };
            default:
              return { min: 1, max: 4 };
          }
        },
        suffix: '',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Number of columns - Mobile',
        element: 'slider',
        accessKey: ['numColumnsMobile'],
        min: 1,
        max: 2,
        dynamicData: true,
        getDynamicData: function (activeWidgetProps) {
          const layoutPresentation = activeWidgetProps?.listPresentation;
          if (layoutPresentation.layoutName === 'layout4') {
            return { min: 1, max: 1 };
          }
          return {
            min: 1,
            max: 2,
          };
        },
        suffix: '',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Review appearance',
        element: 'multiselect',
        accessKey: ['appearance'],
        componentData: PRODUCT_APPEARANCE_DATA,
        renderConditional: true,
        isVisible: (activeWidgetProps) =>
          activeWidgetProps?.listPresentation?.layoutName !== 'layout4',
      },
      {
        element: 'colorDetails',
        componentLabel: 'Colour',
        isVisible: (activeWidgetProps) =>
          activeWidgetProps?.listPresentation?.appearance === 'card',
        conditionalRender: true,
        forType: 'layout',
        colorsData: [
          {
            forType: 'layout',
            text: 'backgroundColor',
            isVisible: (activeWidgetProps) =>
              activeWidgetProps?.listPresentation?.appearance === 'card',
            renderConditional: true,
            displayVal: 'Background colour',
            accessKey: ['backgroundColor'],
            shouldUpdateData: false,
            data: [],
          },
          {
            forType: 'layout',
            text: 'borderColor',
            isVisible: (activeWidgetProps) =>
              activeWidgetProps?.listPresentation?.appearance === 'card',
            renderConditional: true,
            displayVal: 'Border colour',
            accessKey: ['borderColor'],
            shouldUpdateData: false,
            data: [],
          },
        ],
      },
    ],
  },
  testimonialsContent: {
    sectionHeading: 'Testimonials content',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'card',
        componentLabel: 'Content alignment',
        element: 'multiselect',
        accessKey: ['textAlign'],
        componentData: HEADING_ALIGNMENT,
      },
      {
        forType: 'card',
        element: 'dropdown',
        componentLabel: 'Product testimonial text size - Desktop',
        accessKey: ['textSizeDesktop'],
        dropdownData: TEXT_SIZE_DROPDOWN,
        customChildRender: false,
        placeholder: '',
      },
      {
        forType: 'card',
        element: 'dropdown',
        componentLabel: 'Product testimonial text size - Mobile',
        accessKey: ['textSizeMobile'],
        dropdownData: TEXT_SIZE_DROPDOWN,
        customChildRender: false,
        placeholder: '',
      },
      // {
      //   forType: 'card',
      //   element: 'dropdown',
      //   componentLabel: 'Headline size - Desktop',
      //   accessKey: ['headlineSizeDesktop'],
      //   dropdownData: TEXT_SIZE_DROPDOWN,
      //   customChildRender: false,
      //   placeholder: '',
      // },
      // {
      //   forType: 'card',
      //   element: 'dropdown',
      //   componentLabel: 'Headline size - Mobile',
      //   accessKey: ['headlineSizeMobile'],
      //   dropdownData: TEXT_SIZE_DROPDOWN,
      //   customChildRender: false,
      //   placeholder: '',
      // },
      {
        componentLabel: 'Advanced settings',
        componentSubLabel: 'Customise Text casing, content thickness, colour.',
        element: 'customModal',
        modalHeading: 'Advance settings',
        componentData: [
          {
            element: 'colorDetails',
            componentLabel: 'Colours',
            forType: 'card',
            colorsData: [

              {
                forType: 'card',
                text: 'reviewColor',
                displayVal: 'Review color',
                accessKey: ['reviewColor'],
                shouldUpdateData: false,
                data: [],
              },
              {
                forType: 'card',
                text: 'authorNameColor',
                displayVal: 'Author name color',
                accessKey: ['authorNameColor'],
                shouldUpdateData: false,
                data: [],
              },
              {
                forType: 'card',
                text: 'ratingColor',
                displayVal: 'Rating color',
                accessKey: ['ratingColor'],
                shouldUpdateData: false,
                data: [],
              },
            ],
          },
          {
            forType: 'card',
            componentLabel: 'Review text case',
            element: 'multiselect',
            accessKey: ['textCase'],
            componentData: TEXT_CASE,
          },
          {
            forType: 'card',
            element: 'dropdown',
            componentLabel: 'Review thickness',
            accessKey: ['textThickness'],
            dropdownData: TEXT_THICKNESS,
            customChildRender: false,
            placeholder: '',
          },
        ],
      },
    ],
  },
  carouselBehaviour: {
    sectionHeading: 'Carousel behaviour',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'layout',
        componentLabel: '',
        element: 'radioButton',
        accessKey: ['autoPlayConfig', 'type'],
        conditionalStyle: false,
        componentData: [
          {
            label: 'Manual scroll (default)',
            id: 'autoOff',
            value: SCROLL_TYPE.MANUAL,
          },
          {
            label: 'Auto-scroll',
            id: 'autoOn',
            value: SCROLL_TYPE.AUTO_SCROLL,
            child: [
              {
                forType: 'layout',
                element: 'multiselect',
                componentData: SPEED_OPTION,
                renderConditional: true,
                accessKey: ['autoPlayConfig', 'autoplayTimer'],
                isVisible: (activeWidgetProps) => {
                  return (
                    activeWidgetProps?.listPresentation?.autoPlayConfig?.type ===
                    SCROLL_TYPE.AUTO_SCROLL
                  );
                },
                placeholder: '',
              },
            ],
          },
          {
            label: 'Auto-rotate testimonials',
            id: 'autoOn',
            value: SCROLL_TYPE.AUTO_ROTATE,
            child: [
              {
                forType: 'layout',
                element: 'autoSlide',
                componentLabel: 'Change testimonial every:',
                accessKey: ['autoPlayConfig', 'autoRotateTimer'],
                min: 4,
                max: 6,
                renderConditional: true,
                isVisible: (activeWidgetProps) => {
                  return (
                    activeWidgetProps?.listPresentation?.autoPlayConfig?.type ===
                    SCROLL_TYPE.AUTO_ROTATE
                  );
                },
                placeholder: '',
              },
            ],
          },
        ],
      },
    ],
  },
  reelBehaviour: {
    sectionHeading: 'Autoplay',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'layout',
        componentLabel: '',
        element: 'radioButton',
        accessKey: ['autoPlayConfig', 'type'],
        conditionalStyle: false,
        componentData: [
          {
            label: 'On',
            id: 'autoOn',
            value: SCROLL_TYPE.AUTO_ROTATE,
            child: [
              {
                forType: 'layout',
                element: 'autoSlide',
                componentLabel: 'Change testimonial every:',
                accessKey: ['autoPlayConfig', 'autoRotateTimer'],
                min: 4,
                max: 6,
                renderConditional: true,
                isVisible: (activeWidgetProps) => {
                  return (
                    activeWidgetProps?.listPresentation?.autoPlayConfig?.type ===
                    SCROLL_TYPE.AUTO_ROTATE
                  );
                },
                placeholder: '',
              },
            ],
          },
          {
            label: 'Off',
            id: 'autoOff',
            value: SCROLL_TYPE.MANUAL,
          },
        ],
      },
    ],
  },
  contentOrderSection: {
    sectionHeading: 'Content order',
    description: '',
    tooltipContent: '',
    builder: [
      {
        forType: 'card',
        componentLabel: 'Product position',
        element: 'multiselect',
        accessKey: ['productPosition'],
        dynamicData: true,
        getDynamicData: (({ listPresentation }) => {
          if (listPresentation?.layoutName === COMMON_LAYOUT_TYPE.ONE || listPresentation?.layoutName === COMMON_LAYOUT_TYPE.THREE) {
            return PRODUCT_CONTENT_CONFIG_FOR_L1_L2
          }
          return PRODUCT_CONTENT_CONFIG_FOR_L3
        }),
        renderConditional: true,
        dynamicSubText: (({ listPresentation }) => {
          if (listPresentation?.layoutName === COMMON_LAYOUT_TYPE.TWO) {
            return 'Image Positioned at the Top in Mobile for optimal viewing experience.'
          }
        }),
        isVisible: ({ listPresentation }) => listPresentation?.layoutName !== COMMON_LAYOUT_TYPE.FOUR
      },
    ],
  },
  viewAllButton: {
    builder: [
      {
        forType: 'layout',
        element: 'button',
        buttonHeading: 'View all',
        subHeading:
          'This button will be visible when all testimonials are not in display at front.',
        showColorCombination: true,
        showDeleteIcon: false,
        showRedirectionField: false,
        accessKey: ['viewAllItemsButtonConfig'],
      },
    ],
  },
  sectionSetting: {
    sectionHeading: 'Section settings',
    builder: [
      {
        forType: 'layout',
        componentLabel: 'Desktop padding top and bottom',
        element: 'slider',
        accessKey: ['paddingY'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Mobile padding top and bottom',
        element: 'slider',
        accessKey: ['mobilePaddingY'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Margin top',
        element: 'slider',
        accessKey: ['marginTop'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
      {
        forType: 'layout',
        componentLabel: 'Margin bottom',
        element: 'slider',
        accessKey: ['marginBottom'],
        min: 0,
        max: 100,
        suffix: 'px',
        step: 1,
      },
    ],
  },
  configReset: {
    builder: [
      {
        forType: 'layout',
        element: 'reset',
        heading: 'Reset to defaults',
        subHeading:
          'All settings of this section - layout, design etc. will be reset to default.',
      },
    ],
  },
};

export const CARD = 'card';
